import { Tooltip } from '@mui/material';
import { dateHeader, formatCellDate } from './timeModeCell';

export const makeReaderLogColumn = () => {
  const renderSeverity = (severity: number) => {
    return (
      <span
        style={{
          color: severity === 0 ? 'blue' : severity === 1 ? 'orange' : 'red',
        }}
      >
        {severity === 0 ? 'Information' : severity === 1 ? 'Warning' : 'Alert'}
      </span>
    );
  };

  return [
    {
      header: dateHeader('Timestamp'),
      accessorKey: 'timestamp',
      size: 110,
      style: { textAlign: 'center' },
      cell: ({ row, table }) => formatCellDate(table, row.original.timestamp),
    },
    {
      header: 'User',
      accessorKey: 'createdUserName',
      enableColumnFilter: true,
      size: 150,
      cell: ({ row }) => (
        <Tooltip title={row.original.createdUserId} disableInteractive>
          {row.original.createdUserName}
        </Tooltip>
      ),
    },
    {
      header: 'Category',
      accessorKey: 'category',
      enableColumnFilter: true,
      size: 200,
    },
    {
      header: 'Severity',
      accessorKey: 'severity',
      size: 90,
      cell: ({ row }) => renderSeverity(row.original.severity),
      style: {
        textAlign: 'center',
      },
    },
    {
      header: 'Message',
      accessorKey: 'message',
      size: 'auto',
      style: { textAlign: 'left' },
    },
  ] as Array<any>;
};
